import React, { useState, useEffect } from "react"
import submitHandler from "../../services/submitHandler"
import { ConfigProvider, Modal, theme } from "antd"
import botStore from "../../stores/botStore"
import settingsStore from "../../stores/settingsStore"

function calculateVariablesPrice(variables, settings, expiresInDays, useRanksystem) {
    const keyToPriceMap = new Map(settings.map((s) => [s.name, s.price]))

    let calculatedPrice = keyToPriceMap.get("createBanner") || 0
    let calculationDescLines = [
        { type: "remove", text: `مقدار ${calculatedPrice} بابت ساخت بنر جدید` },
    ]

    /// Calculate ranksystem price
    if (useRanksystem) {
        const ranksystemMonthPrice = keyToPriceMap.get("useRanksystem") || 0
        const ranksystemPriceTillExpire = Math.floor((ranksystemMonthPrice / 30) * expiresInDays)

        calculationDescLines.push({
            type: "remove",
            text: `مقدار ${ranksystemPriceTillExpire} از حساب شما بابت فعال کردن گزینه رنک سیستم`,
        })

        calculatedPrice += ranksystemPriceTillExpire
    }

    for (let variable of variables) {
        const variableMonthPrice = keyToPriceMap.get(variable.key) || 0

        const variablePriceTillExpire = Math.floor((variableMonthPrice / 30) * expiresInDays)

        calculationDescLines.push({
            type: "remove",
            text: `مقدار ${variablePriceTillExpire} از حساب شما بابت متغیر ${variable.key} کسر میشود`,
            price: variablePriceTillExpire,
        })

        calculatedPrice += variablePriceTillExpire
    }

    return { calculatedPrice, calculationDescLines }
}

const CreateButton = ({ texts, imageFile, useRanksystem, ranksystemConfig }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [variables, setVariables] = useState([])
    const [calculation, setCalculation] = useState(0)

    const settings = settingsStore((state) => state.settings)
    const bot = botStore((state) => state.bot)

    useEffect(() => {
        if (isOpen) {
            const newVariables = texts.map((t) => ({
                id: t.id,
                key: t.variable.key,
                fill: t.fill,
                fontSize: t.fontSize,
                fontWeight: t.fontWeight,
                fontFamily: t.fontFamily,
                rotation: t.rotation,
                x: t.x,
                y: t.y,
                options: t.options,
            }))

            setVariables(newVariables)

            const diff = calculateVariablesPrice(
                newVariables, // Use the local variable, not state
                settings,
                bot?.expiresInDays,
                useRanksystem
            )

            setCalculation(diff)
        }
    }, [isOpen])

    const toggleModal = () => setIsOpen(!isOpen)

    return (
        <>
            <button onClick={toggleModal} className="btn btn-success outline-none">
                ساخت بنر
            </button>
            <ConfigProvider direction="rtl" theme={{ algorithm: theme.darkAlgorithm }}>
                <Modal
                    title="ساخت بنر"
                    open={isOpen}
                    onCancel={toggleModal}
                    onOk={() => {
                        toggleModal()
                        submitHandler.create(variables, imageFile, useRanksystem, ranksystemConfig)
                    }}
                    okText={"ساخت"}
                    footer={(_, { OkBtn, CancelBtn }) => (
                        <>
                            <div className="flex justify-between mx-2">
                                <div>
                                    مجموع: {calculation?.calculatedPrice?.toLocaleString("en-US")}{" "}
                                    تومان
                                </div>
                                <div className="flex gap-2">
                                    <CancelBtn />
                                    <OkBtn />
                                </div>
                            </div>
                        </>
                    )}
                    cancelText={"بیخیال!"}
                >
                    <>
                        <div>
                            تعداد روز باقیمانده از بات بنر داینامیک شما: {bot?.expiresInDays} روز
                        </div>
                        <div className="bg-stone-800 mt-5 p-2 border-sky-500 border-2 rounded-md">
                            {useRanksystem && (
                                <>
                                    <div className="text-rose-500">
                                        دقت کنید که بعد از فعال کردن رنک سیستم درصورت حذف یا
                                        برداشتن این گزینه مبلغ باقیمانده اضافه نمیشود
                                    </div>
                                    <br />
                                </>
                            )}
                            {calculation &&
                                calculation.calculationDescLines.map(({ type, text }) => (
                                    <div className="text-rose-500">{text}</div>
                                ))}
                        </div>
                    </>
                </Modal>
            </ConfigProvider>
        </>
    )
}

export default CreateButton
